export enum ExternalReviewSource {
    Google = 'GOOGLE',
    TripAdvisor = 'TRIP_ADVISOR',
}

export class CommunicationPreferences {

    constructor(
        public sendReminderHours: number | null,
        public sendFeedbackRequest: boolean,
        public sendFeedbackRequestMinutes: number,
        public externalReviewSource: ExternalReviewSource | null,
        public externalReviewUrl: string | null,
        public externalReviewCount: number | null,
        public externalReviewDescription: string | null,
        public emailAddresses: string[] | null,
        public replyToEmailAddress: string | null,
        public feedbackEmailRecipients: string[] | null,
        public upcomingEmailRecipients: string[] | null,
        public sendRequestEmail: boolean,
        public sendConfirmationEmail: boolean,
        public sendWaitlistJoinedMerchantEmail: boolean,
        public sendCancellationEmail: boolean,
        public sendModificationEmail: boolean,
        public sendNoShowEmail: boolean,
        public sendEmailPerReviewCount: boolean,
        public sendFeedbackDailySummaryEmail: boolean,
        public sendUpcomingEmail: boolean,
        public sendNotificationWithNoteOnly: boolean,
        public sendNotificationMinimumPartySizeOnly: number | null,
        public diningInformation: string | null,
        public messagesEnabled: boolean,
        public messageNotificationEmail: string | null,
        public sendCustomerCommunicationViaSMS: boolean,
        public sendNotificationVIPOnly: boolean,
        public cancellationEmailWording: string | null = null,
        public noShowEmailWording: string | null = null,
        public preOrderMenuEmailWording: string | null = null,
    ) { }

    isInternalFeedbackEnabled() {
        return this.externalReviewSource === null
    }

    getExternalReviewSourceAsString() {
        switch(this.externalReviewSource) {
            case ExternalReviewSource.Google:
                return "Google"
            case ExternalReviewSource.TripAdvisor:
                return "TripAdvisor"
            default:
                return ""
        }
    }
}
